import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onDownloadClick: (platform: 'android' | 'ios') => void;
}

export default function CTASection({ onDownloadClick }: CTASectionProps) {
  return (
    <section className="py-20 bg-gradient-to-br from-primary to-primary-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <div className="inline-flex items-center space-x-2 bg-white/20 px-4 py-2 rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} variant="solid" />
            <span className="text-sm font-semibold">Limited Time Offer</span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-6">
            Start Your Free Trial Today
          </h2>
          <p className="text-lg text-primary-foreground/90 mb-8 max-w-3xl mx-auto">
            Download now and get 30 days of premium access absolutely free. No credit card required. Cancel anytime.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button
              onClick={() => onDownloadClick('android')}
              className="group flex items-center justify-center space-x-3 bg-white text-primary px-8 py-4 rounded-xl font-cta font-bold transition-all duration-300 hover:bg-primary-foreground hover:shadow-warm-2xl hover:scale-105"
            >
              <Icon name="DevicePhoneMobileIcon" size={24} />
              <div className="text-left">
                <div className="text-xs opacity-80">Download on</div>
                <div className="text-lg">Google Play</div>
              </div>
            </button>

            <button
              onClick={() => onDownloadClick('ios')}
              className="group flex items-center justify-center space-x-3 bg-white text-primary px-8 py-4 rounded-xl font-cta font-bold transition-all duration-300 hover:bg-primary-foreground hover:shadow-warm-2xl hover:scale-105"
            >
              <Icon name="DevicePhoneMobileIcon" size={24} />
              <div className="text-left">
                <div className="text-xs opacity-80">Download on</div>
                <div className="text-lg">App Store</div>
              </div>
            </button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 text-sm text-primary-foreground/90">
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={20} variant="solid" />
              <span>No Credit Card Required</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={20} variant="solid" />
              <span>Cancel Anytime</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={20} variant="solid" />
              <span>Instant Access</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}